import { render } from "./thread_tree.vue?vue&type=template&id=5a0b496c"
import script from "./thread_tree.js?vue&type=script&lang=js&external"
export * from "./thread_tree.js?vue&type=script&lang=js&external"

import "./thread_tree.vue?vue&type=style&index=0&id=5a0b496c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__